// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select_icon__1TxWi {\n  fill: #333333;\n  width: 16px;\n  height: 16px;\n  transform: rotate(180deg);\n  transition: all 0.7s ease;\n  margin-right: 4px;\n  cursor: pointer;\n  position: absolute;\n  right: 4px; }\n  .select_icon__1TxWi.select_open__ZXqvG {\n    transform: rotate(-180deg);\n    transition: all 0.7s ease; }\n", ""]);
// Exports
exports.locals = {
	"icon": "select_icon__1TxWi",
	"open": "select_open__ZXqvG"
};
module.exports = exports;
